import { roundToTwo } from "./Results/Stats";

export let currentTab = -1;
export const times:{number:number}|{} = {};
export let lastChange = 0;
export let startTime = 0;
export let endTime = 0;
export let minutesTotal = 0;
export let totalTime = 0;
export let tabs:Array<HTMLElement>;
export const ab = "#ab-form";
export const examHolder = "#ab";
export const nextTaskBtn = ".right > button";
export const lastTaskBtn = ".previous-task";
export const pointsDisplay = "#punkte-anzeige";
export const questionDisplay = ".fragen-nummer";
export const totalTasksWrapper = ".total-tasks";
export const currentTaskWrapper = ".current-task";
export const timerBtn = "#timer-button";

// Config
export const showNote = true;
export const showTimeAnalysis = true;
export let stopTimer = false;

export const submitButtons = $(".submit-ab")

const buttons = {
    nextButton: '<span class="md-hide">Nächste Aufgabe</span> <span><i class="ti-arrow-right"></i></span>',
    sendButton: '<span class="md-hide">Absenden</span> <span><i class="fas fa-paper-plane"></i></span>',
    prevButton: '<span class="md-hide">Letzte Aufgabe</span> <span><i class="ti-arrow-left"></i></span>',
}

export function loadExam(){
    tabs = document.getElementsByClassName("tab");
    loadTimer();
    setTotalTasks();
    showTask(0);
    initSubmitButtons("submit");
}

export function initSubmitButtons(status){
    submitButtons.attr('data-status', status);
}


export function reloadTasks(){
    currentTab = 0;
    tabs = document.getElementsByClassName("tab");
}

export function showTask(n:number){
    // Close last Tab if there was one
    if (currentTab != -1){
        tabs[currentTab].style.display = "none";
        tabs[currentTab].classList.remove("p-active");
    }
    // Check if not going backwards behind 0
    if (n <= 0){
        n = 0;
    }

    logTimeChange();

    handleTaskButtons(n);

    if (tabs.length){
        tabs[n].style.display = "block";
        tabs[n].classList.add("p-active");
        currentTab = n;
        // Here resize
        setDisplays(tabs[n], n);
        //
    }

}

export function jumpToTask(n:number){
    if (tabs.length){

        showTask(n);

    }
}

export function takeStep(step:number){

    if (!tabs[currentTab + step].classList.contains("task-inactive")){
        showTask(currentTab + step);
    }
}


/**
 * Show Tasks
 */

function setTotalTasks(){
    const wrapper = $(totalTasksWrapper);
    if (wrapper){
        wrapper.html(tabs.length);
    }
}

function changeTotalTasks(n:number){
    const wrapper = $(totalTasksWrapper);
    if (wrapper){
        wrapper.html(n);
    }
}

function setCurrentTask(index:number){
    const wrapper = $(currentTaskWrapper);
    if (wrapper){
        wrapper.html(index);
    }
}


function handleTaskButtons(n:number):void{
    // First send Button
    if (n === tabs.length - 1){
        $(nextTaskBtn).html(buttons.sendButton)
        $(nextTaskBtn).addClass("submit-ab").removeClass("next-task");
    } else {
        $(nextTaskBtn).html(buttons.nextButton);
        $(nextTaskBtn).removeClass("submit-ab").addClass("next-task")
    }
    // Now first button
    if (n == 0){
        $(lastTaskBtn).css('visibility', 'hidden');
    } else {
        $(lastTaskBtn).css('visibility', 'visible');
    }
}


export function logTimeChange(){
    const now = new Date();
    const addition = now - lastChange;
    const tab = (currentTab == -1) ? 0 : currentTab;
    const taskId = getCurrentlyViewedTaskId(tab);
    times[taskId]["time"] = times[taskId]["time"] + addition;
    lastChange = now;
}

export function getCurrentlyViewedTaskId(tab:number){
    const taskId = tabs[tab].getAttribute('data-aufgabe');
    return taskId;
}



/**
 * Sets displays like points or Question Name/Nr
 * @param tab
 */
function setDisplays(tab:HTMLElement, n:number){
    const points = tab.getAttribute('data-punkte')
    const questionNr = Number(tab.getAttribute('data-index')) + 1;
    // Set display Points
    const displayPoints = $(".task-points");
    if (displayPoints !== null){
        displayPoints.html('Punkte: ' + roundToTwo(points));
    }
    // Set question Nr:
    $(questionDisplay).html("Frage: " + questionNr.toString());
}

/**
 * Timer
 */
function loadTimer(){
    if (tabs.length) {
        for (let s = 0; s < tabs.length; s++){
            const taskId = getCurrentlyViewedTaskId(s);
            times[taskId] = {};
            times[taskId]["time"] = 0;
        }
        if (showTimeAnalysis){
        // Init necessary values
            totalTime = $(ab).attr('data-minuten');
            startTime = new Date();
            endTime = new Date();
            endTime.setMinutes(startTime.getMinutes() + totalTime);
            minutesTotal = totalTime;
            lastChange = new Date();

            loadTimerFunctions();
        } else {
            $(timerBtn).remove();
        }
    }
}

export function stopTimerRunning(){
    stopTimer = true
}


function loadTimerFunctions(){
    (function f(){
        if (!stopTimer){
            let diff = new Date() - startTime, ns = (((minutesTotal * 60 * 1000 - diff) / 1000) >> 0),
            m = (ns / 60) >> 0, s = ns - m * 60;


            const timer = $(timerBtn);
            // Time is up -> count up
            if (s < 0){
                m = m * (-1)
                s = s * (-1);

                timer.html(m + ':' + (('' + s).length > 1 ? '' : '0') + s);
                timer.addClass("timer-end");
            } else {
                // Time is not up
                timer.html(m + ':' + (('' + s).length > 1 ? '' : '0') + s);
            }
        }
        setTimeout(f, 1000); // set timeout for one second
    })()
}